import { render, staticRenderFns } from "./KiraAlacakKalemiForm.vue?vue&type=template&id=124190b6"
import script from "./KiraAlacakKalemiForm.vue?vue&type=script&lang=ts"
export * from "./KiraAlacakKalemiForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports